export type HealthStatus = 'healthy' | 'attention' | 'action-needed' | 'no-data';

export const HEALTH_STATUS_CONFIG: Record<HealthStatus, { label: string; color: string; mapFill: string; mapLine: string }> = {
    healthy: {
        label: 'Healthy',
        color: '#22c55e',
        mapFill: '#22c55e',
        mapLine: '#15803d',
    },
    attention: {
        label: 'Attention',
        color: '#f59e0b',
        mapFill: '#f59e0b',
        mapLine: '#b45309',
    },
    'action-needed': {
        label: 'Action needed',
        color: '#ef4444',
        mapFill: '#ef4444',
        mapLine: '#b91c1c',
    },
    'no-data': {
        label: 'No data',
        color: '#94a3b8',
        mapFill: '#94a3b8',
        mapLine: '#64748b',
    },
};
